"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringMatcherContext = void 0;
var constants_1 = require("../../logger/constants");
function stringMatcherContext(log, ruleAttr) {
    return function stringMatcher(runtimeAttr) {
        var re;
        try {
            re = new RegExp(ruleAttr);
        }
        catch (e) {
            log.debug(constants_1.ENGINE_MATCHER_STRING_INVALID, [ruleAttr]);
            return false;
        }
        var regexMatches = re.test(runtimeAttr);
        log.debug(constants_1.ENGINE_MATCHER_STRING, [runtimeAttr, ruleAttr, regexMatches ? 'yes' : 'no']);
        return regexMatches;
    };
}
exports.stringMatcherContext = stringMatcherContext;
